import { render, staticRenderFns } from "./CaseView.vue?vue&type=template&id=d04c523c&scoped=true&"
import script from "./CaseView.vue?vue&type=script&lang=js&"
export * from "./CaseView.vue?vue&type=script&lang=js&"
import style0 from "./CaseView.vue?vue&type=style&index=0&id=d04c523c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04c523c",
  null
  
)

export default component.exports